var _baseTheme$palette, _baseTheme$palette2, _baseTheme$palette3, _baseTheme$palette4, _baseTheme$palette5;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { lighten } from '@mui/system';
import { createTheme } from '@mui/material';
import { baseTheme } from "./base";
var _createTheme = createTheme(),
  breakpoints = _createTheme.breakpoints,
  spacing = _createTheme.spacing;
var colors = {
  lightBlue: '#F2F4FE',
  mediumBlue: '#D9E0FC',
  darkblue: '#142178',
  text: '#071973',
  placeholders: '#6973A1',
  disabledText: '#afb6d8',
  buttons: {
    disabled: '#a0aadc',
    main: '#112AA7'
  },
  primary: '#309BB0',
  borders: {
    light: 'rgb(7 25 115 / 10%)'
  },
  inputs: {
    background: '#FFFFFF'
  },
  alerts: {
    info: {
      color: '#2746E9',
      background: '#F2F4FE'
    }
  }
};
var fontSizes = {
  body0: '20px',
  body1: '16px',
  body2: '14px'
};
export var psDoctorsTheme = _objectSpread(_objectSpread({
  name: 'Doctors'
}, baseTheme), {}, {
  palette: _objectSpread(_objectSpread({}, baseTheme.palette), {}, {
    text: {
      primary: colors.text
    },
    background: {
      default: colors.lightBlue,
      paper: colors.darkblue
    },
    primary: _objectSpread(_objectSpread({}, (_baseTheme$palette = baseTheme.palette) === null || _baseTheme$palette === void 0 ? void 0 : _baseTheme$palette.primary), {}, {
      main: colors.primary,
      light: colors.mediumBlue
    }),
    secondary: _objectSpread(_objectSpread({}, (_baseTheme$palette2 = baseTheme.palette) === null || _baseTheme$palette2 === void 0 ? void 0 : _baseTheme$palette2.secondary), {}, {
      main: lighten('#2746E9', 0.1)
    }),
    success: _objectSpread(_objectSpread({}, (_baseTheme$palette3 = baseTheme.palette) === null || _baseTheme$palette3 === void 0 ? void 0 : _baseTheme$palette3.success), {}, {
      main: '#00C087'
    }),
    error: _objectSpread(_objectSpread({}, (_baseTheme$palette4 = baseTheme.palette) === null || _baseTheme$palette4 === void 0 ? void 0 : _baseTheme$palette4.error), {}, {
      main: '#E30000'
    }),
    warning: _objectSpread(_objectSpread({}, (_baseTheme$palette5 = baseTheme.palette) === null || _baseTheme$palette5 === void 0 ? void 0 : _baseTheme$palette5.warning), {}, {
      main: '#E30000'
    })
  }),
  typography: {
    colors: {
      main: colors.text,
      placeholder: colors.placeholders,
      buttons: {
        main: colors.buttons.main,
        disabled: colors.buttons.disabled
      }
    },
    fontFamily: ['Inter', 'IBM Plex Mono', 'sans-serif'].join(','),
    h1: {
      fontWeight: 600,
      fontSize: '76px',
      lineHeight: 1.2,
      letterSpacing: 0
    },
    h2: {
      fontWeight: 500,
      fontSize: '32px',
      lineHeight: 1.2,
      letterSpacing: 0
    },
    h3: _defineProperty({
      fontWeight: 600,
      letterSpacing: '0.01em',
      fontSize: 18,
      lineHeight: 1.6
    }, breakpoints.up('sm'), {
      fontSize: 18
    }),
    h4: {
      fontWeight: 600,
      fontSize: '31px',
      lineHeight: 1.2,
      letterSpacing: 0
    },
    h5: {
      fontWeight: 600,
      fontSize: '25px',
      lineHeight: 1.2,
      letterSpacing: 0
    },
    h6: {
      fontWeight: 500,
      fontSize: '20px',
      lineHeight: 1.2,
      letterSpacing: 0
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: '20px',
      lineHeight: 1.2,
      letterSpacing: 0
    },
    subtitle2: {
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: 1.2,
      letterSpacing: 0
    },
    body0: {
      fontWeight: 400,
      fontSize: fontSizes.body0,
      lineHeight: 1.2,
      letterSpacing: 0
    },
    body1: {
      fontWeight: 600,
      fontSize: fontSizes.body1,
      lineHeight: 1.2,
      letterSpacing: 0
    },
    body2: _defineProperty({
      fontWeight: 400,
      fontSize: fontSizes.body2,
      lineHeight: 1.2,
      letterSpacing: 0
    }, breakpoints.down('md'), {
      fontSize: 14,
      lineHeight: '20px'
    }),
    button: {
      fontWeight: 'normal',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: 0,
      textTransform: 'none'
    },
    caption: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: 1.2,
      letterSpacing: 0
    },
    overline: {
      fontWeight: 400,
      fontSize: '10px',
      lineHeight: 1.2,
      letterSpacing: 0
    },
    borders: {
      colors: {
        light: colors.borders.light
      },
      light: "2px solid ".concat(colors.borders.light)
    }
  },
  button: {
    borderRadius: '8px',
    paddingX: '18px',
    paddingY: '16px'
  },
  input: {
    defaultVariant: 'filled',
    filled: {
      paddingX: spacing(3),
      paddingY: spacing(2),
      borderRadius: '8px',
      border: "1px solid lightgrey",
      fontFamily: 'Inter',
      backgroundColor: '#FFFFFF'
    }
  },
  components: {
    MuiFilledInput: {
      styleOverrides: {
        root: {
          background: "".concat(colors.inputs.background, " !important"),
          border: "2px solid ".concat(colors.borders.light, " !important")
        },
        input: {
          '&::placeholder': {
            color: "".concat(colors.text, " !important")
          }
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          margin: '0 !important'
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          borderBottom: "2px solid ".concat(colors.disabledText),
          color: "".concat(colors.disabledText),
          "&.Mui-selected": {
            color: colors.text,
            borderBottom: "2px solid ".concat(colors.text)
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          display: 'none'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        label: {
          whiteSpace: 'break-spaces',
          fontSize: "".concat(fontSizes.body2, " !important")
        },
        root: {
          padding: "".concat(spacing(2), " !important"),
          fontWeight: 'normal'
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          background: 'white'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-disabled.no-style-disabled": {
            opacity: 1
          },
          fontWeight: 400,
          fontSize: fontSizes.body2
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        content: {
          margin: '0 !important'
        },
        expandIconWrapper: {
          transform: 'transform: rotate(270deg)'
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '8px'
        },
        filledInfo: {
          color: colors.text,
          background: colors.mediumBlue
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px'
        },
        text: {
          width: 'auto',
          minWidth: 'auto',
          padding: '0'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          ".bg-white &": {
            borderColor: colors.mediumBlue
          }
        },
        input: {
          fontWeight: 400,
          fontSize: fontSizes.body2,
          "&::placeholder": {
            opacity: 1,
            color: colors.placeholders
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          ".default-select &": {
            color: colors.placeholders
          },
          height: '1.28em',
          fontWeight: 400,
          fontSize: fontSizes.body2
        }
      }
    },
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: '#dcdcdc'
        }
      }
    }
  }
});
//# sourceMappingURL=sc-vars-doctors.js.map